export const NotificationStrings = {
  en: {
    notification: 'Notifications'
  }
}
